<template>
  <v-card-text
    class="text-center grey--text title pa-6 notification-disabled-message"
    data-testid="notification-not-enabled-message__main"
  >
    {{ message }}
  </v-card-text>
</template>

<script>
export default {
  name: "NotificationDisabledMessage",
  props: {
    message: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import './NotificationNotEnabledMessage.scss';
</style>